import _createClass from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _classCallCheck from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _toConsumableArray from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _regeneratorRuntime from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import { isHexString } from './index.js';
// methods that require user interaction
var methods = ['eth_sendTransaction', 'eth_signTransaction', 'personal_sign', 'eth_sign', 'eth_signTypedData', 'eth_signTypedData_v4'];
function walletConnect(options) {
  if (!options || options.version !== 2) {
    throw new Error('WalletConnect requires a projectId. Please visit https://cloud.walletconnect.com to get one.');
  }
  var projectId = options.projectId,
    handleUri = options.handleUri,
    requiredChains = options.requiredChains,
    qrModalOptions = options.qrModalOptions;
  return function () {
    return {
      label: 'WalletConnect',
      getIcon: function () {
        var _getIcon = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
          return _regeneratorRuntime().wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return import('./icon.js');
              case 2:
                return _context.abrupt("return", _context.sent.default);
              case 3:
              case "end":
                return _context.stop();
            }
          }, _callee);
        }));
        function getIcon() {
          return _getIcon.apply(this, arguments);
        }
        return getIcon;
      }(),
      getInterface: function () {
        var _getInterface = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(_ref) {
          var chains, EventEmitter, appMetadata, _yield$import, ProviderRpcError, ProviderRpcErrorCode, _yield$import2, EthereumProvider, _yield$import3, Subject, fromEvent, _yield$import4, takeUntil, take, getMetaData, requiredChainsParsed, connector, emitter, EthProvider;
          return _regeneratorRuntime().wrap(function _callee5$(_context5) {
            while (1) switch (_context5.prev = _context5.next) {
              case 0:
                chains = _ref.chains, EventEmitter = _ref.EventEmitter, appMetadata = _ref.appMetadata;
                _context5.next = 3;
                return import('@web3-onboard/common');
              case 3:
                _yield$import = _context5.sent;
                ProviderRpcError = _yield$import.ProviderRpcError;
                ProviderRpcErrorCode = _yield$import.ProviderRpcErrorCode;
                _context5.next = 8;
                return import('@walletconnect/ethereum-provider');
              case 8:
                _yield$import2 = _context5.sent;
                EthereumProvider = _yield$import2.default;
                _context5.next = 12;
                return import('rxjs');
              case 12:
                _yield$import3 = _context5.sent;
                Subject = _yield$import3.Subject;
                fromEvent = _yield$import3.fromEvent;
                _context5.next = 17;
                return import('rxjs/operators');
              case 17:
                _yield$import4 = _context5.sent;
                takeUntil = _yield$import4.takeUntil;
                take = _yield$import4.take;
                getMetaData = function getMetaData() {
                  if (!appMetadata) return undefined;
                  var wcMetaData = {
                    name: appMetadata.name,
                    description: appMetadata.description || '',
                    url: appMetadata.explore || appMetadata.gettingStartedGuide || '',
                    icons: []
                  };
                  if (appMetadata.icon !== undefined && appMetadata.icon.length) {
                    wcMetaData.icons = [appMetadata.icon];
                  }
                  if (appMetadata.logo !== undefined && appMetadata.logo.length) {
                    wcMetaData.icons = wcMetaData.icons.length ? [].concat(_toConsumableArray(wcMetaData.icons), [appMetadata.logo]) : [appMetadata.logo];
                  }
                  return wcMetaData;
                }; // default to mainnet
                requiredChainsParsed = Array.isArray(requiredChains) && requiredChains.length && requiredChains.every(function (num) {
                  return !isNaN(num);
                }) ?
                // @ts-ignore
                // Required as WC package does not support hex numbers
                requiredChains.map(function (chainID) {
                  return parseInt(chainID);
                }) : [1];
                _context5.next = 24;
                return EthereumProvider.init({
                  projectId: projectId,
                  chains: requiredChainsParsed,
                  metadata: getMetaData(),
                  showQrModal: true,
                  optionalChains: chains.map(function (_ref2) {
                    var id = _ref2.id;
                    return parseInt(id, 16);
                  }),
                  optionalMethods: methods,
                  rpcMap: chains.map(function (_ref3) {
                    var id = _ref3.id,
                      rpcUrl = _ref3.rpcUrl;
                    return {
                      id: id,
                      rpcUrl: rpcUrl
                    };
                  }).reduce(function (rpcMap, _ref4) {
                    var id = _ref4.id,
                      rpcUrl = _ref4.rpcUrl;
                    rpcMap[parseInt(id, 16)] = rpcUrl || '';
                    return rpcMap;
                  }, {}),
                  qrModalOptions: qrModalOptions
                });
              case 24:
                connector = _context5.sent;
                emitter = new EventEmitter();
                EthProvider = /*#__PURE__*/_createClass(function EthProvider(_ref5) {
                  var _this = this;
                  var connector = _ref5.connector,
                    chains = _ref5.chains;
                  _classCallCheck(this, EthProvider);
                  this.emit = emitter.emit.bind(emitter);
                  this.on = emitter.on.bind(emitter);
                  this.removeListener = emitter.removeListener.bind(emitter);
                  this.connector = connector;
                  this.chains = chains;
                  this.disconnected$ = new Subject();
                  // listen for accountsChanged
                  fromEvent(this.connector, 'accountsChanged', function (payload) {
                    return payload;
                  }).pipe(takeUntil(this.disconnected$)).subscribe({
                    next: function next(accounts) {
                      _this.emit('accountsChanged', accounts);
                    },
                    error: console.warn
                  });
                  // listen for chainChanged
                  fromEvent(this.connector, 'chainChanged', function (payload) {
                    return payload;
                  }).pipe(takeUntil(this.disconnected$)).subscribe({
                    next: function next(chainId) {
                      var hexChainId = "0x".concat(chainId.toString(16));
                      _this.emit('chainChanged', hexChainId);
                    },
                    error: console.warn
                  });
                  // listen for disconnect event
                  fromEvent(this.connector, 'session_delete', function (payload) {
                    return payload;
                  }).pipe(takeUntil(this.disconnected$)).subscribe({
                    next: function next() {
                      _this.emit('accountsChanged', []);
                      _this.disconnected$.next(true);
                      typeof localStorage !== 'undefined' && localStorage.removeItem('walletconnect');
                    },
                    error: console.warn
                  });
                  this.disconnect = function () {
                    if (_this.connector.session) _this.connector.disconnect();
                  };
                  if (options && handleUri) {
                    // listen for uri event
                    fromEvent(this.connector, 'display_uri', function (payload) {
                      return payload;
                    }).pipe(takeUntil(this.disconnected$)).subscribe( /*#__PURE__*/function () {
                      var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(uri) {
                        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
                          while (1) switch (_context2.prev = _context2.next) {
                            case 0:
                              _context2.prev = 0;
                              _context2.t0 = handleUri;
                              if (!_context2.t0) {
                                _context2.next = 5;
                                break;
                              }
                              _context2.next = 5;
                              return handleUri(uri);
                            case 5:
                              _context2.next = 10;
                              break;
                            case 7:
                              _context2.prev = 7;
                              _context2.t1 = _context2["catch"](0);
                              throw "An error occurred when handling the URI. Error: ".concat(_context2.t1);
                            case 10:
                            case "end":
                              return _context2.stop();
                          }
                        }, _callee2, null, [[0, 7]]);
                      }));
                      return function (_x2) {
                        return _ref6.apply(this, arguments);
                      };
                    }());
                  }
                  var checkForSession = function checkForSession() {
                    var session = _this.connector.session;
                    if (session) {
                      _this.emit('accountsChanged', _this.connector.accounts);
                      _this.emit('chainChanged', _this.connector.chainId);
                    }
                  };
                  checkForSession();
                  this.request = /*#__PURE__*/function () {
                    var _ref8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(_ref7) {
                      var method, params, chainIdObj;
                      return _regeneratorRuntime().wrap(function _callee4$(_context4) {
                        while (1) switch (_context4.prev = _context4.next) {
                          case 0:
                            method = _ref7.method, params = _ref7.params;
                            if (!(method === 'eth_chainId')) {
                              _context4.next = 3;
                              break;
                            }
                            return _context4.abrupt("return", isHexString(_this.connector.chainId) ? _this.connector.chainId : "0x".concat(_this.connector.chainId.toString(16)));
                          case 3:
                            if (!(method === 'eth_requestAccounts')) {
                              _context4.next = 5;
                              break;
                            }
                            return _context4.abrupt("return", new Promise( /*#__PURE__*/function () {
                              var _ref9 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(resolve, reject) {
                                var accounts, chainId, hexChainId;
                                return _regeneratorRuntime().wrap(function _callee3$(_context3) {
                                  while (1) switch (_context3.prev = _context3.next) {
                                    case 0:
                                      // Subscribe to connection events
                                      fromEvent(_this.connector, 'connect', function (payload) {
                                        return payload;
                                      }).pipe(take(1)).subscribe({
                                        next: function next(_ref10) {
                                          var chainId = _ref10.chainId;
                                          _this.emit('accountsChanged', _this.connector.accounts);
                                          var hexChainId = isHexString(chainId) ? chainId : "0x".concat(chainId.toString(16));
                                          _this.emit('chainChanged', hexChainId);
                                          resolve(_this.connector.accounts);
                                        },
                                        error: reject
                                      });
                                      // Check if connection is already established
                                      if (_this.connector.session) {
                                        _context3.next = 6;
                                        break;
                                      }
                                      _context3.next = 4;
                                      return _this.connector.connect().catch(function (err) {
                                        console.error('err creating new session: ', err);
                                        reject(new ProviderRpcError({
                                          code: 4001,
                                          message: 'User rejected the request.'
                                        }));
                                      });
                                    case 4:
                                      _context3.next = 11;
                                      break;
                                    case 6:
                                      // update ethereum provider to load accounts & chainId
                                      accounts = _this.connector.accounts;
                                      chainId = _this.connector.chainId;
                                      hexChainId = "0x".concat(chainId.toString(16));
                                      _this.emit('chainChanged', hexChainId);
                                      return _context3.abrupt("return", resolve(accounts));
                                    case 11:
                                    case "end":
                                      return _context3.stop();
                                  }
                                }, _callee3);
                              }));
                              return function (_x4, _x5) {
                                return _ref9.apply(this, arguments);
                              };
                            }()));
                          case 5:
                            if (!(method === 'eth_selectAccounts')) {
                              _context4.next = 7;
                              break;
                            }
                            throw new ProviderRpcError({
                              code: ProviderRpcErrorCode.UNSUPPORTED_METHOD,
                              message: "The Provider does not support the requested method: ".concat(method)
                            });
                          case 7:
                            if (!(method == 'wallet_switchEthereumChain')) {
                              _context4.next = 14;
                              break;
                            }
                            if (params) {
                              _context4.next = 10;
                              break;
                            }
                            throw new ProviderRpcError({
                              code: ProviderRpcErrorCode.INVALID_PARAMS,
                              message: "The Provider requires a chainId to be passed in as an argument"
                            });
                          case 10:
                            chainIdObj = params[0];
                            if (!(!chainIdObj.hasOwnProperty('chainId') || typeof chainIdObj['chainId'] === 'undefined')) {
                              _context4.next = 13;
                              break;
                            }
                            throw new ProviderRpcError({
                              code: ProviderRpcErrorCode.INVALID_PARAMS,
                              message: "The Provider requires a chainId to be passed in as an argument"
                            });
                          case 13:
                            return _context4.abrupt("return", _this.connector.request({
                              method: 'wallet_switchEthereumChain',
                              params: [{
                                chainId: chainIdObj.chainId
                              }]
                            }));
                          case 14:
                            return _context4.abrupt("return", _this.connector.request({
                              method: method,
                              params: params
                            }));
                          case 15:
                          case "end":
                            return _context4.stop();
                        }
                      }, _callee4);
                    }));
                    return function (_x3) {
                      return _ref8.apply(this, arguments);
                    };
                  }();
                });
                return _context5.abrupt("return", {
                  provider: new EthProvider({
                    chains: chains,
                    connector: connector
                  })
                });
              case 28:
              case "end":
                return _context5.stop();
            }
          }, _callee5);
        }));
        function getInterface(_x) {
          return _getInterface.apply(this, arguments);
        }
        return getInterface;
      }()
    };
  };
}
export default walletConnect;